<template>

  <div class="exhibit" :style="{'background-image': 'url('+ backgroundImage +')'}">
    <div class="top">
      <back-button />
      <help-button />
    </div>
    <div class="content">
      <h1 class="logo bodyFont fontBold">{{ exhibit.name }}</h1>
      <p v-if="exhibitdata && exhibitdata.location"><strong>{{ exhibitdata.location }}</strong></p>
      <div class="textbox" v-if="exhibitdata && inrange" v-html="exhibitdata.description"></div>

      <template v-if="exhibitdata && inrange">

        <template v-if="exhibitdata.content_type == 'pano'">
          <div class="textbox">
            <p><strong>For the best experience, turn your phone horizontal when viewing 360&deg; content.</strong></p>
          </div>
          <p><img class="rotate" src="../assets/exhibit/rotate.png"></p>
          <p>
            <router-link class="button" :to="{path:'pano'}">
              View the 360&deg; Video
            </router-link>
          </p>
        </template>

        <template v-else>
          <div class="textbox">
            <p><strong>View exclusive content to learn more.</strong></p>
          </div>
          <p>
            <router-link class="button" :to="{path:'seasons'}">
              View Now
            </router-link>
          </p>
        </template>
      </template>

      <template v-else>
        <div class="textbox">
          <p>Please come back later to see more content.</p>
        </div>
        <p v-if="$store.state.inzone">You are {{ distance() }} ft away</p>
        <button @click="$router.go(-1)">Close</button>
      </template>

    </div>
  </div>
</template>

<script>

export default {
  name: 'Exhibit',
  props: {
    exhibitslug:{
      type:String,
      default:''
    }
  },
  computed: {
    exhibits () {
      return this.$store.state.exhibits
    },
    exhibitdata () {
      return this.$store.state.exhibit_data[this.exhibitid]
    },
    exhibit () {
      return this.exhibits[this.exhibitid]
    },
    name () {
      return this.exhibitid ? this.exhibit.name : ''
    },
    backgroundImage () {
      return this.exhibitdata.background_image ? this.exhibitdata.background_image : ''
    },
    inrange () {
      return true
      // return this.$store.state.distances[this.exhibitid] <= 20
    },
    exhibitid () {
      return this.$store.state.exhibitnames[this.exhibitslug]
    }
  },
  methods: {
    distance () {
      return Math.round(this.$store.state.distances[this.exhibitid] * 3.2808)
    }
  }
}
</script>

<style lang="scss" scoped>
.exhibit {
  color: #000;
  height: 100%;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
}
.top {
  padding: 10px;
  display: flex;
  justify-content: space-between;
}
.content {
  color: #000;
  background-color: white;
  padding: 20px;
  margin: 30px;
  margin-top: 0;
  overflow: auto;
  flex: 1;
  .rotate {
    display: inline-block;
    max-width: 60%;
  }
}
</style>
